import React from "react";
import { AddTemplateCategorySection } from "./Addtemplatecategorysection";

export const AddTemplateAuthSection: React.FC = () => (
  <AddTemplateCategorySection category="AUTHENTICATION" />
);